/**
 * Contact.js
 *
 * Responsive Contact Page:
 * - Image at top on mobile
 * - Text centered below the image (both horizontally & vertically aligned)
 * - Smooth fade-in animations using Framer Motion
 */

import React from "react";
import { motion } from "framer-motion";
import Anushka from "../assets/Anushka.png";

const Contact = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-black text-white px-6 py-16">
            
            {/* --- IMAGE + TEXT WRAPPER --- */}
            <div className="flex flex-col items-center justify-center w-full max-w-3xl">
                
                {/* --- IMAGE SECTION --- */}
                <motion.div
                    initial={{ opacity: 0, y: -40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    className="w-full flex justify-center"
                >
                    <img
                        src={Anushka}
                        alt="Contact Banner"
                        className="rounded-3xl shadow-xl object-cover w-full max-w-3xl"
                    />
                </motion.div>

                {/* --- TEXT SECTION --- */}
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, ease: "easeOut" }}
                    className="w-full flex justify-center mt-8"
                >
                    <p className="text-center text-xl text-zinc-400 leading-relaxed max-w-xl">
                        Bahut Jaldi mein ho.
                    </p>
                </motion.div>
            </div>
        </div>
    );
};

export default Contact;